"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertVoidBlock = exports.insertPAboveLeadingVoid = void 0;
const slate_1 = require("slate");
const createParagraph = () => ({ type: 'p', children: [{ text: '' }] });
const isAtEmptyParagraph = (entry) => !!entry && entry[0].type === 'p' && slate_1.Node.string(entry[0]) === '';
/**
 * If the caret/selection is on the very first block and that block is a void,
 * prepend an empty paragraph and move the caret into it.
 */
const insertPAboveLeadingVoid = (editor) => {
    const { selection } = editor;
    if (!selection)
        return false;
    if (selection.anchor.path[0] !== 0)
        return false;
    const first = editor.children?.[0];
    if (!slate_1.Element.isElement(first))
        return false;
    if (!slate_1.Editor.isVoid(editor, first))
        return false;
    slate_1.Transforms.insertNodes(editor, createParagraph(), { at: [0] });
    slate_1.Transforms.select(editor, slate_1.Editor.start(editor, [0]));
    return true;
};
exports.insertPAboveLeadingVoid = insertPAboveLeadingVoid;
/**
 * Insert a void block element at the current selection. Mirrors the pattern
 * shared by `<embed>`, `<hr>`, `<file>`, and any future block voids:
 *
 *   1. If the caret is in an empty paragraph, replace it with the void.
 *   2. Otherwise insert the void at the caret.
 *   3. Ensure there's a paragraph immediately after, and place the caret in it.
 *
 * Returns the inserted node (echoing the input), or `null` if there was no
 * selection and Slate refused to insert.
 */
const insertVoidBlock = (editor, element) => {
    const { selection } = editor;
    const currentBlockEntry = (selection
        ? slate_1.Editor.above(editor, {
            at: slate_1.Editor.unhangRange(editor, selection),
            match: (node) => slate_1.Element.isElement(node) && slate_1.Editor.isBlock(editor, node),
            mode: 'lowest',
        })
        : null);
    let insertedPath = null;
    if (isAtEmptyParagraph(currentBlockEntry)) {
        const [, path] = currentBlockEntry;
        slate_1.Transforms.removeNodes(editor, { at: path });
        slate_1.Transforms.insertNodes(editor, element, { at: path, select: true });
        insertedPath = path;
    }
    else {
        slate_1.Transforms.insertNodes(editor, element, { select: true });
        // After insertion, the new node is wherever Slate placed it. Resolve via
        // the editor's current selection.
        const after = editor.selection;
        if (after)
            insertedPath = [after.anchor.path[0]];
    }
    if (!insertedPath)
        return null;
    const afterPath = slate_1.Path.next(insertedPath);
    if (!slate_1.Node.has(editor, afterPath)) {
        slate_1.Transforms.insertNodes(editor, createParagraph(), { at: afterPath });
    }
    if (slate_1.Node.has(editor, afterPath)) {
        slate_1.Transforms.select(editor, slate_1.Editor.start(editor, afterPath));
    }
    return element;
};
exports.insertVoidBlock = insertVoidBlock;
